(function (angular, app) {
    'use strict';

    app.directive('backgroundImg', ['Config', 'Api', '$filter', 'ADVERTISEMENT_AD_TYPE', 'ADVERTISEMENT_GROUP_TYPE', 'Util', function (Config, Api, $filter, ADVERTISEMENT_AD_TYPE, ADVERTISEMENT_GROUP_TYPE, Util) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                images: '='
            },
            templateUrl:'template/directives/background-img/index.html',
            controller: ['$scope', '$rootScope', '$timeout', '$filter', 'Util', '$element', 'Config', function ($scope, $rootScope, $timeout, $filter, Util, $element, Config) {
                var backgroundImgCtrl = this,
                    _translateFilter = $filter('translate'),
                    plasmaPayload = null,
                    _timeout;

                backgroundImgCtrl.changeImage = changeImage;
                backgroundImgCtrl.pauseAutoChange = pauseAutoChange;
                backgroundImgCtrl.isAutoChangePaused = false;
                backgroundImgCtrl.isFocusPaused = false;

                function _insertPlasmaIntoCurrentCarousel() {
                    if (!plasmaPayload || !plasmaPayload.url) {
                        return;
                    }
                    var arr = Config.retailer.homeCarouselImages;
                    if (!arr || !arr.length) {
                        return;
                    }
                    var exists = arr.some(function (img) {
                        return img.adId === plasmaPayload.adId;
                    });
                    if (exists) {
                        return;
                    }
                    arr.splice(1, 0, angular.extend({}, plasmaPayload));
                }

                function _nextImage() {
                    var ret = backgroundImgCtrl.active + 1;

                    if (ret === backgroundImgCtrl.images.length) {
                        ret = 0;
                    }

                    return ret;
                }

                function _previousImageIndex() {
                    var len = backgroundImgCtrl.images.length;
                    if (!len) {
                        return 0;
                    }
                    var ret = backgroundImgCtrl.active - 1;
                    if (ret < 0) {
                        ret = len - 1;
                    }
                    return ret;
                }

                function cancelAutoTimer() {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                        _timeout = null;
                    }
                }

                function changeImage(changeToIndex, manually) {
                    if ((backgroundImgCtrl.isAutoChangePaused || backgroundImgCtrl.isFocusPaused) && !manually) {
                        cancelAutoTimer();
                        return;
                    }

                    cancelAutoTimer();

                    var fromIndex = backgroundImgCtrl.active;
                    var toIndex = changeToIndex !== undefined ? changeToIndex : _nextImage();
                    var carouselImages = backgroundImgCtrl.images || [];
                    if (manually && fromIndex !== undefined && fromIndex !== toIndex && carouselImages.length > 1 && $rootScope.SP_SERVICES && $rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS) {
                        var toBanner = carouselImages[toIndex];
                        var ctx = $rootScope.homeBannerAnalyticsContext || {};
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_HOME_BANNER_NAVIGATED, {
                            bannerId: toBanner && (toBanner.id || toBanner.adId),
                            navigationDirection: 'Direct Selection',
                            fromBannerPosition: fromIndex + 1, 
                            toBannerPosition: toIndex + 1,
                            totalActiveBanners: carouselImages.length,
                            branchTargetingType: Util.getHomeBannerBranchTargetingType(toBanner),
                            targetedBranchesCount: Util.getHomeBannerTargetedBranchesCount(toBanner)
                        });
                    }

                    backgroundImgCtrl.active = toIndex;

                    _timeout = $timeout(changeImage, (Config.retailer.settings.homePageImagesSliderInterval || 10) * 1000);

                    if (manually) {
                        _setAlertElement(changeToIndex);
                    }
                }

                function shouldPauseAutoForFocusTarget(target) {
                    if (!target || !target.closest) {
                        return false;
                    }
                    return !!target.closest('.item, .item-button, a, button');
                }

                function onBannerFocusIn(ev) {
                    if (!shouldPauseAutoForFocusTarget(ev.target)) {
                        return;
                    }
                    if (backgroundImgCtrl.isFocusPaused) {
                        cancelAutoTimer();
                        return;
                    }
                    backgroundImgCtrl.isFocusPaused = true;
                    cancelAutoTimer();
                }

                function onBannerFocusOut() {
                    $timeout(function () {
                        var root = $element && $element[0];
                        if (!root || (document.activeElement && root.contains(document.activeElement))) {
                            return;
                        }
                        backgroundImgCtrl.isFocusPaused = false;
                        if (!backgroundImgCtrl.isAutoChangePaused) {
                            changeImage(backgroundImgCtrl.active, false);
                        }
                    }, 0);
                }

                var rawBannerEl = $element[0];

                function handleBannerArrowKeys(domEvent) {
                    if (!domEvent || domEvent.altKey || domEvent.ctrlKey || domEvent.metaKey) {
                        return;
                    }
                    var active = document.activeElement;
                    if (!rawBannerEl || !active) {
                        return;
                    }
                    if (!rawBannerEl.contains(active) && active !== rawBannerEl) {
                        return;
                    }
                    var tag = active.nodeName ? active.nodeName.toUpperCase() : '';
                    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
                        return;
                    }
                    if (active.isContentEditable) {
                        return;
                    }
                    var keyCode = domEvent.keyCode || domEvent.which;
                    var evtKey = domEvent.key;
                    var arrowLeft = evtKey === 'ArrowLeft' || keyCode === 37;
                    var arrowRight = evtKey === 'ArrowRight' || keyCode === 39;
                    if (!arrowLeft && !arrowRight) {
                        return;
                    }
                    var images = backgroundImgCtrl.images;
                    if (!images || images.length <= 1) {
                        return;
                    }
                    domEvent.preventDefault();
                    var ltr = Config.language.direction === 'ltr';
                    var goPrev = ltr ? arrowLeft : arrowRight;
                    $scope.$evalAsync(function () {
                        if (goPrev) {
                            changeImage(_previousImageIndex(), true);
                        } else {
                            changeImage(_nextImage(), true);
                        }
                    });
                }

                document.addEventListener('keydown', handleBannerArrowKeys, true);

                $element.on('focusin', onBannerFocusIn);
                $element.on('focusout', onBannerFocusOut);
                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', handleBannerArrowKeys, true);
                    $element.off('focusin', onBannerFocusIn);
                    $element.off('focusout', onBannerFocusOut);
                });

                function pauseAutoChange() {
                    backgroundImgCtrl.isAutoChangePaused = !backgroundImgCtrl.isAutoChangePaused;

                    if (!backgroundImgCtrl.isAutoChangePaused){
                        changeImage();
                    }
                }

                function _setAlertElement($index) {
                    var $oldElement = angular.element(document.querySelector('.choose-alert'));
                    if (!!$oldElement) {
                        $oldElement.remove();
                    }

                    var $alertElement = angular.element(document.createElement('div'))
                        .addClass('choose-alert sr-only-element');

                    $alertElement[0].setAttribute('aria-live', 'assertive');
                    $alertElement[0].setAttribute('role', 'alert');
                    $alertElement[0].setAttribute('aria-relevant', 'additions');
                    $alertElement.text(_translateFilter('displays image') + ' ' + ($index + 1) + ' ' + _translateFilter('of') + ' ' + backgroundImgCtrl.images.length);

                    document.body.appendChild($alertElement[0]);
                }

                function _syncCarouselFromConfig(images) {
                    backgroundImgCtrl.images = images || [];
                    _insertPlasmaIntoCurrentCarousel();
                    changeImage(0);
                }

                var _offHomeCarouselUpdate = $rootScope.$on('config.homeCarouselImages.updated', function (event, images) {
                    _syncCarouselFromConfig(images);
                });
                $scope.$on('$destroy', _offHomeCarouselUpdate);

                Api.request({
                    method: 'GET',
                    url: '/v2/retailers/:rid/native-promotion',
                    params: {
                        groupType: ADVERTISEMENT_GROUP_TYPE.PLASMA,
                    }
                }).then(function (resp) {
                    if (resp && resp.advertisements && resp.advertisements.plasma && resp.advertisements.plasma.length) {
                        plasmaPayload = {
                            href: resp.advertisements.plasma[0].url,
                            url: resp.advertisements.plasma[0].pictureUrl,
                            adId: resp.advertisements.plasma[0].adId
                        };
                        _insertPlasmaIntoCurrentCarousel();
                        changeImage(0);
                    }
                });

                _syncCarouselFromConfig(Config.retailer.homeCarouselImages);
            }],
            controllerAs: 'backgroundImgCtrl'
        };
    }]);
})(angular, app);
